// ** React Imports
import { useState, useEffect } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    IconButton,
    Tooltip,
    InputLabel,
    Select,
    MenuItem,
    Chip
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../icon';
import apiUrl from '../../configs/constant';
import MsiDatagrid from '../custom/MsiDatagridAuto';

import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormHelperText,
    Typography,
} from '@mui/material'

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import { Controller, useForm } from 'react-hook-form'
import { useToast } from '../ToastProvider'

interface Props {
    mmgudangId?: number | string | null;
}
export default function Index({ mmgudangId }: Props) {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const cabang = JSON.parse(localStorage.getItem('cabang')!)
    const token = userData.token

    const { showToast, hideToast } = useToast();

    // ** State
    const [tglAwal, setTglAwal] = useState<string>(moment().subtract(3, 'months').startOf('month').format('YYYY-MM-DD'))
    const [tglAkhir, setTglAkhir] = useState<string>(moment().endOf('month').format('YYYY-MM-DD'))

    const [listData, setListData] = useState<any[]>([])
    const [listSubGudang, setListSubGudang] = useState<any[]>([])
    const [openDialog, setOpenDialog] = useState<boolean>(false)
    const [loadingData, setLoadingData] = useState<boolean>(false)

    useEffect(() => {
        getData()
        getSubGudang(mmgudangId)
    }, [mmgudangId])

    const navigate = useNavigate();

    const getData = () => {
        setLoadingData(true)

        let url = apiUrl.apiUrl + '/gudang/stock-opname/list-new';

        axios
            .get(url, {
                params: { mmgudang_sub_id: mmgudangId, tgl_awal: tglAwal, tgl_akhir: tglAkhir },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListData(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
            .catch(error => {
                showToast(error.response?.data?.message || error.message, 'error')
            })
            .finally(() => setLoadingData(false))
    }

    const getSubGudang = (gudangId: any) => {
        const url = apiUrl.apiUrl + '/mm/sub-gudang/list-combo'
        axios
            .get(url, {
                params: { mmgudang_id: gudangId },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSubGudang(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const convertComponent = [
        {
            key: 'status',
            renderCell: ({ value }: any) => {
                const adjusted = value === 'Penyesuaian langsung'
                const pending = String(value || '').startsWith('Menunggu')
                return <Chip size='small' label={value || 'Draft'} color={adjusted ? 'success' : pending ? 'warning' : 'default'} />
            }
        },
        {
            key: 'total_adjustment',
            renderCell: ({ value }: any) => (
                <Typography fontWeight={700} color={Number(value) === 0 ? 'text.secondary' : Number(value) > 0 ? 'success.main' : 'error.main'}>
                    {new Intl.NumberFormat('id-ID', { maximumFractionDigits: 3 }).format(Number(value) || 0)}
                </Typography>
            )
        },
        {
            key: 'jumlah_duplikat',
            renderCell: ({ value }: any) => Number(value) > 0
                ? <Chip size='small' color='error' label={`${value} duplikat`} />
                : <Chip size='small' color='success' variant='outlined' label='Aman' />
        }
    ]

    interface FormInputs {
        mmgudang_id: number | string | null;
        mmgudang_sub_id: number;
        keterangan: string;
        pic: string;
        sysdoctag_id: any
    }

    const defaultValues = {
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        watch,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const handleDelete = (row: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin hapus data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Hapus'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const data = {}
                const url = apiUrl.apiUrl + '/gudang/stock-opname/delete-opname-new/' + row.id
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    getData()
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    };

    const ActionButtons = ({
        row,
        onDelete,
        onNavigate
    }: {
        row: any
        onDelete: (row: any) => void
        onNavigate: (id: string) => void
    }) => {
        const actions = [
            {
                title: 'Lihat Detail',
                icon: 'mdi:search',
                color: '#0984e3', // biru terang seperti "primary"
                onClick: () => onNavigate(row.id)
            },
            ...(Number(row.is_aktif) === 0 ? [{
                title: 'Hapus Opname',
                icon: 'mdi:trash',
                color: '#d63031', // merah terang seperti "error"
                onClick: () => onDelete(row)
            }] : []),
            {
                title: 'Download PDF',
                icon: 'mdi:file-pdf',
                color: '#e73e33',
                href: `${apiUrl.baseUrl}/warehouse/gudang/detail-opname-pdf-new/${row.id}`,
                target: '_blank'
            }
        ]

        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {actions.map(action => (
                    <Tooltip key={action.title} title={action.title} placement='top'>
                        {action.href ? (
                            <a
                                href={action.href}
                                target={action.target || '_self'}
                                rel='noopener noreferrer'
                                style={{ textDecoration: 'none' }}
                            >
                                <IconButton component='span'>
                                    <Icon icon={action.icon} color={action.color} />
                                </IconButton>
                            </a>
                        ) : (
                            <a
                                onClick={action.onClick}
                                style={{ cursor: 'pointer', textDecoration: 'none' }}
                            >
                                <IconButton component='span'>
                                    <Icon icon={action.icon} color={action.color} />
                                </IconButton>
                            </a>
                        )}
                    </Tooltip>
                ))}
            </Box>
        )
    }

    const actionData = [
        {
            key: "aksi",
            flex: 1,
            sortable: false,
            minWidth: 200,
            field: "aksi",
            align: "center",
            headerAlign: "center",
            headerName: "Aksi",
            renderCell: ({ row }: { row: any }) => (
                <ActionButtons
                    row={row}
                    onDelete={handleDelete}
                    onNavigate={(id) => navigate('/gudang/view-opname-new/' + id + '?view=0')}
                />
            ),
        },
    ];

    return (
        <Grid container spacing={3} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12}>
                <Box
                    sx={{
                        mb: 3,
                        width: '100%',
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 2
                    }}
                >
                    <Box>
                        <Typography variant='h6' fontWeight={800}>Riwayat stock opname</Typography>
                        <Typography variant='body2' color='text.secondary'>
                            Pantau hasil hitung fisik dan status otorisasi dalam satu tempat.
                        </Typography>
                    </Box>
                    <Button
                        variant='contained'
                        startIcon={<Icon icon='mdi:plus' />}
                        onClick={() => setOpenDialog(true)}
                        sx={{ borderRadius: 2.5, px: 2.5, height: 44, textTransform: 'none', fontWeight: 700 }}
                    >
                        Buat Opname
                    </Button>
                </Box>
                <Box sx={{ bgcolor: '#f7f9fc', border: '1px solid', borderColor: 'divider', borderRadius: 3, p: 2, mb: 3 }}>
                    <Grid
                        container
                        alignItems='center'
                        spacing={2}
                    >
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <TextField
                                    label='Tanggal Awal'
                                    type='date'
                                    onChange={(e) => setTglAwal(e.target.value)}
                                    value={tglAwal}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>

                                <TextField
                                    label='Tanggal Akhir'
                                    type='date'
                                    onChange={(e) => setTglAkhir(e.target.value)}
                                    value={tglAkhir}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <FormControl fullWidth>
                                <Button
                                    variant='contained'
                                    sx={{ height: 56, borderRadius: 2, textTransform: 'none', fontWeight: 700 }}
                                    startIcon={<Icon icon='mdi:magnify' />}
                                    onClick={() => getData()}
                                >
                                    Cari Data
                                </Button>
                            </FormControl>
                        </Grid>
                    </Grid>
                </Box>
                <MsiDatagrid
                    title="Riwayat stock opname"
                    array={listData}
                    loading={loadingData}
                    actions={actionData}
                    customRender={convertComponent}
                    convertNumeric={['total_item', 'total_stok_sistem', 'total_stok_fisik']}
                    hiddenColumns={['mmgudang_id', 'is_aktif', 'ot_now', 'ot_max']}
                />
            </Grid>

            <Dialog
                maxWidth={'sm'}
                fullWidth={true}
                open={openDialog}
                onClose={() => setOpenDialog(false)}
                aria-labelledby='form-dialog-title'
            >
                <form onSubmit={handleSubmit((data) => {
                    let url = apiUrl.apiUrl + '/gudang/stock-opname/save-opname-new';

                    axios.post(url, {
                        mmgudang_sub_id: data.mmgudang_sub_id,
                        mmgudang_id: mmgudangId,
                        pic: data.pic,
                        keterangan: data.keterangan,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                        .then(response => {
                            if (response.data.success) {
                                showToast(response.data.message, 'success');
                                setOpenDialog(false);
                                navigate('/gudang/view-opname-new/' + response.data.data);
                            } else {
                                showToast(response.data.message, 'error');
                                setOpenDialog(false);
                            }
                        })
                        .catch(error => {
                            showToast(error.message, 'error');
                        });
                })}>
                    <DialogTitle id='form-dialog-title'>
                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5, color: '#212121' }}>
                            Buat Stock Opname
                        </Typography>
                    </DialogTitle>
                    <DialogContent dividers sx={{ p: 2 }}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12}>
                                <FormControl fullWidth>
                                    <InputLabel>Sub Gudang</InputLabel>
                                    <Controller
                                        name='mmgudang_sub_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Select
                                                label='Sub Gudang'
                                                value={value || ''}
                                                onChange={onChange}
                                                error={Boolean(errors.mmgudang_sub_id)}
                                            >
                                                {listSubGudang.map((item: any, index: any) => (
                                                    <MenuItem value={item.id} key={index}>
                                                        {item.nama}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.mmgudang_sub_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pic'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='PIC'
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.pic && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControl fullWidth>
                                    <Controller
                                        name='keterangan'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                value={value}
                                                label='Keterangan'
                                                multiline
                                                rows={3}
                                                InputLabelProps={{ shrink: true }}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                </FormControl>
                                {errors.keterangan && (
                                    <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                )}
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions className='dialog-actions-dense'>
                        <Button variant='contained' type='submit'>Simpan</Button>
                        <Button onClick={() => setOpenDialog(false)}>Batal</Button>
                    </DialogActions>
                </form>
            </Dialog>
        </Grid>
    )
}
